export class AppSettings {
  //public static API_ENDPOINT = 'http://localhost/bitz/web/app_dev.php';
  public static API_ENDPOINT = 'http://meuhotel.bitzsoftwares.com.br';
}
